import { Component, computed, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { CardType } from '@models/card.model';
import { Global } from '@services/global.service';
import { Router } from '@services/route.service';

@Component({
  selector: 'lgb-type-card-stat',
  imports: [
    UiModule,
    RouterModule
  ],
  templateUrl: './type-card-stat.html',
  styleUrl: './type-card-stat.css',
})
export class TypeCardStat {
  //services
  readonly globalS=inject(Global);
  readonly router=inject(Router)

  //data
  readonly _types=signal<CardType[]>([]);
  readonly types=computed(() => this._types().sort((a: CardType, b: CardType) => a.index-b.index))

  //ui
  readonly loading=signal(false);

  constructor(){
    this.loading.set(true);
    this.globalS.getTypes()
      .subscribe(types => {
        this._types.set(types);
        this.loading.set(false);
      });
  }
}
